var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.value),function(v,index){return [(v)?_c('b-badge',{key:index,staticClass:"mr-1",attrs:{"pill":""}},[_vm._v(" "+_vm._s(_vm.$t(_vm.fieldConfig.valueToLabel[index.substr(0, 3)]).substr(0, 2))+" ")]):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }